module.exports = __webpack_public_path__ + "static/img/img-computer-right.8706f49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-computer-right.png
// module id = EGpJ
// module chunks = 1